function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Table-View",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "TV-|-Initial",
  transform: "translate(-27.000000, -94.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Logo-Tractiq",
  transform: "translate(27.000000, 94.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.14009777,6.7252241 C2.23472539,6.53528201 2.33764445,6.35025108 2.4484601,6.1705295",
  id: "Fill-12",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.37496849,7.35090475 L0.905174402,6.09949036 C1.01796421,5.87331194 1.1423357,5.64965547 1.27499863,5.43449396 L3.62186894,6.90651194 C3.53329538,7.05026266 3.45011783,7.19972094 3.37496849,7.35090475",
  id: "Fill-13",
  fill: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5581498,14.3918893 C16.3713682,13.0855231 16.8435851,11.5426253 16.8435851,9.88969112 C16.8435851,8.22335083 16.3649194,6.60970586 15.4594422,5.22316845 L13.1513969,6.75637673 C13.7586456,7.68630982 14.0797742,8.76994867 14.0797742,9.88969112 C14.0797742,13.0361462 11.5415428,15.5959177 8.42172674,15.5959177 C5.30191064,15.5959177 2.76381093,13.0361462 2.76381093,9.88969112 C2.76381093,8.77114327 3.08428139,7.68856629 3.69021403,6.75916414 L1.38111581,5.22754867 C0.477612851,6.61315694 -3.54916097e-13,8.2252091 -3.54916097e-13,9.88969112 C-3.54916097e-13,14.573071 3.77799793,18.3833278 8.42172674,18.3833278 C10.3819267,18.3833278 12.1861688,17.7025361 13.6188758,16.5658037",
  id: "Fill-14",
  fill: "#171B60"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-18",
  fill: "#171B60",
  points: "15.2143449 13.8817004 17.5739813 15.3480108 15.7376264 18.0983881 12.1907357 15.7678478"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.40789452,5.46657572 C5.96547532,5.46657572 3.98553381,7.4634232 3.98553381,9.9266973 C3.98553381,12.3898387 5.96547532,14.3868189 8.40789452,14.3868189 C10.8503137,14.3868189 12.8302552,12.3898387 12.8302552,9.9266973 C12.8302552,7.4634232 10.8503137,5.46657572 8.40789452,5.46657572 M8.40789452,8.24907464 C9.32508492,8.24907464 10.0713139,9.00167536 10.0713139,9.9266973 C10.0713139,10.8517192 9.32508492,11.6041872 8.40789452,11.6041872 C7.49070412,11.6041872 6.74447517,10.8517192 6.74447517,9.9266973 C6.74447517,9.00167536 7.49070412,8.24907464 8.40789452,8.24907464",
  id: "Fill-19",
  fill: "#0000FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5208778,5.51558799e-14 C15.2622641,0.324268705 14.1826669,1.31950683 13.6892608,1.77996043 C13.0406865,2.38522662 12.5445167,2.36452014 11.592318,1.96565504 C10.8651725,1.66103094 9.86177752,1.36184892 8.40788136,1.36184892 C6.03666319,1.36184892 3.76796925,2.38310288 2.18351592,4.16399245 L4.4120688,5.73091511 C5.47403025,4.53737266 6.81921651,4.14434784 8.40788136,4.14434784 C9.31164753,4.14434784 9.90178697,4.3914982 10.5264082,4.65324928 C11.1888016,4.93066295 11.8346121,5.1573723 12.5439902,5.1573723 C13.3660266,5.1573723 14.3317811,4.92309712 15.3905839,3.97046655 C16.2444698,3.20220324 17.4423845,1.93791367 17.4423845,1.93791367 L15.5208778,5.51558799e-14 Z",
  id: "Fill-20",
  fill: "#0000FF"
}))));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logo.a1f98f1f.svg";
export { ForwardRef as ReactComponent };